<template>
  <!-- <div id="app"> -->
  <router-view id="app" />
  <!-- </div> -->
</template>
<script>
import "../src/assets/js/index";
export default {};
</script>

<style>
@import "../src/assets/css/animate.min.css";

@import "../src/assets/css/reset.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,
body {
  padding-bottom: env(safe-area-inset-bottom);
}
@supports (bottom: env(safe-area-inset-bottom)) {
  div {
    margin-bottom: env(safe-area-inset-bottom);
  }
}
.vue-puzzle-vcode {
  z-index: 9999 !important;
}
.el-message-box__wrapper{
  position: absolute !important;
	top: 50% !important;
	height: 240px;
	margin-top: -120px; 
}
</style>
